import { useState, useEffect, useCallback } from "react";
import { Button, Card, Col, Row, Spinner } from "react-bootstrap";
import { ConsumoService } from "../../../../../services/apiService";
import MasterTableConsumos from "../lista-consumo/TablaConsumos";
import { ConsumoTableListTanstack } from "../lista-consumo/MasterTableConsumos";
import SmsIcon from '@mui/icons-material/Sms';
import reporteConsumoStore, { tiposConsumo } from "../../../../../lib/store/reporte_consumo_store";
import dayjs from "dayjs";

const CardConsumos = () => {
    const store = reporteConsumoStore();

    const filtrosEmail = reporteConsumoStore((state) => state.email);
    const filtrosSms = reporteConsumoStore((state) => state.sms);
    const filtrosWhatsapp = reporteConsumoStore((state) => state.whatsapp);
    const filtrosVoz = reporteConsumoStore((state) => state.voz);

    //Datos de pagincacion y filtros de la tabla 
    const PER_PAGE = 100;
    const [searchValue, setSearchValue] = useState('');
    const filtroSelTipoConsumo = (store.selectedTipoConsumo.map(w => w.label.toLowerCase()) || tiposConsumo.map(w => w.label.toLowerCase()));
    const [perPage, setPerPage] = useState(PER_PAGE);
    const handlePageSizeChange = useCallback((newSize) => {
        setPerPage(newSize);
    }, []);

    // Estructura de columnas 
    const columns = [
        {
            accessorKey: 'id', header: 'Alerta', cell: ({ row: { original } }) => (
                <Flex> {/* Ajustar ancho máximo del contenedor */}
                    <span
                        style={style2Lines}
                        title={original.nombrealerta} // Mostrar tooltip con el texto completo
                    >
                        {original.nombrealerta}
                    </span>
                </Flex>
            )
        },
        {
            accessorKey: 'vehiculo', header: 'Vehículo', cell: ({ row: { original } }) => (
                <Flex> {/* Ajustar ancho máximo del contenedor */}
                    <span
                        style={style2Lines}
                        title={original.vehiculo} // Mostrar tooltip con el texto completo
                    >
                        {original.vehiculo}
                    </span>
                </Flex>
            )
        },
        {
            accessorKey: 'fechaHoraEvento', header: 'Fecha', cell: ({ row: { original } }) => (
                <Flex> {/* Ajustar ancho máximo del contenedor */}
                    <span
                        style={style2Lines}
                        title={formatFecha(original.fechaHoraEvento)} // Mostrar tooltip con el texto completo
                    >
                        {formatFecha(original.fechaHoraEvento)}
                    </span>
                </Flex>
            )
        },
        {
            accessorKey: 'destinatario', header: 'Destinatario', cell: ({ row: { original } }) => (
                <Flex> {/* Ajustar ancho máximo del contenedor */}
                    <span
                        style={style2Lines}
                        title={formatPhoneNumber(original.destino)} // Mostrar tooltip con el texto completo
                    >
                        {original.destinatario}
                    </span>
                </Flex>
            )
        },
        {
            accessorKey: 'mensaje',
            header: 'Mensaje',
            cell: ({ row: { original } }) => (
                <Flex> {/* Ajustar ancho máximo del contenedor */}
                    <h6
                        style={style2Lines}
                        title={original.mensaje} // Mostrar tooltip con el texto completo
                    >
                        {original.mensaje}
                    </h6>
                </Flex>
            ),
        },
        {
            accessorKey: 'consumo',
            header: 'Consumo',
            cell: ({ row: { original } }) => {
                var consumo = '';
                switch (original.consumo) {
                    case 'sms':
                        consumo = 'Mensaje SMS';
                        break;
                    case 'email':
                        consumo = 'Mensaje Email';
                        break;
                    case 'whatsapp':
                        consumo = 'Mensaje de Whatsapp';
                        break;
                    case 'voz':
                        consumo = 'Mensaje de voz';
                        break;
                }
                return (
                    <Flex> {/* Ajustar ancho máximo del contenedor */}
                        <h6
                            style={style2Lines}
                            title={consumo} // Mostrar tooltip con el texto completo
                        >
                            {consumo}
                        </h6>
                    </Flex>
                );
            },
        },
        {
            accessorKey: 'destinoSinFormato',
            header: '',
            cell: ({ row: { original } }) => (
                <></>
            ),
        },
    ];
    useEffect(() => {
        const requestConsumptions = async (dt) => {
            try {
                //CARGA DE CONSUMO DE DATOS
                let getDataConsumptions = new URLSearchParams({
                    ...dt.filtros,
                    tipoNotificacion: dt.tipoNotificacion,
                    idempresa: dt.idempresa,
                }).toString()

                const responseConsumptions = await ConsumoService.getNotificationConsumptions(`?${getDataConsumptions}`);
                if (responseConsumptions && responseConsumptions.success) {
                    const data = responseConsumptions.data.map((item) => ({
                        id: item._id,
                        mensaje: item.mensaje,
                        nombrealerta: item.nombrealerta,
                        idvehiculo: item.idvehiculo,
                        vehiculo: `${item.alias} - ${item.placas}`,
                        destinatarioId: item.contactoId,
                        destino: item.destino,
                        destinatario: item.nombreContacto,
                        idTipoAlerta: item.uidtipoalerta,
                        tipoAlerta: item.nombretipoalerta,
                        fechaHoraEvento: item.fechaHoraEvento,
                    }));

                    let newData = data.map(w => ({ ...w, consumo: dt.tipoNotificacion }));
                    switch (dt.tipoNotificacion) {
                        case 'sms':
                            store.editarMensajesSms((newData || []));
                            store.editarMensajesSelSms((newData || []));
                            break;
                        case 'email':
                            store.editarMensajesEmail((newData || []));
                            store.editarMensajesSelEmail((newData || []));
                            break;
                        case 'whatsapp':
                            store.editarMensajesWhatsapp((newData || []));
                            store.editarMensajesSelWhatsapp((newData || []));
                            break;
                        case 'voz':
                            store.editarMensajesVoz((newData || []));
                            store.editarMensajesSelVoz((newData || []));
                            break;
                    }
                }
            } catch (error) {
                console.error("Error al cargar Consumptions:", error);
            } finally {
            }
        }
        if (filtrosEmail !== null || filtrosSms !== null || filtrosWhatsapp !== null || filtrosVoz !== null) {
            if (filtrosEmail !== null)
                requestConsumptions(filtrosEmail);
            if (filtrosSms !== null)
                requestConsumptions(filtrosSms);
            if (filtrosWhatsapp !== null)
                requestConsumptions(filtrosWhatsapp);
            if (filtrosVoz !== null)
                requestConsumptions(filtrosVoz);
        }

    }, [filtrosEmail, filtrosSms, filtrosWhatsapp, filtrosVoz]);

    const formatFecha = (fechaStr) => {
        if (!fechaStr || typeof fechaStr !== 'string') return ' ';

        try {
            let fecha;

            // ✅ DETECTAR FORMATO AUTOMÁTICAMENTE
            if (fechaStr.includes('T')) {
                // Formato ISO: "2025-05-27T20:48:34" o "2025-05-27T20:48:34.000Z. 2025-07-18T19:01:18.803Z"
                fecha = dayjs(fechaStr);
            } else if (fechaStr.includes('/') && fechaStr.includes(' ')) {
                // Formato personalizado: "2025/05/27/ 20:48:34"
                fecha = dayjs(fechaStr, 'YYYY/MM/DD/ HH:mm:ss');
            } else if (fechaStr.includes('-') && fechaStr.includes(' ')) {
                // Formato guión: "2025-05-27 20:48:34"
                fecha = dayjs(fechaStr, 'YYYY-MM-DD HH:mm:ss');
            } else {
                // Parseo automático para otros formatos
                fecha = dayjs(fechaStr);
            }

            // ✅ VERIFICAR VALIDEZ
            if (!fecha.isValid()) {
                console.warn('[formatFecha] Fecha inválida:', fechaStr);
                return 'Fecha inválida';
            }

            // ✅ FORMATEAR (PRESERVA LA ZONA HORARIA LOCAL)
            return fecha.format('DD/MM/YYYY HH:mm:ss');

        } catch (error) {
            console.error('[formatFecha] Error al formatear:', fechaStr, error);
            return 'N/A';
        }
    };

    const formatTypeConsumo = (original) => {

        var consumo = '';

        switch (original.consumo) {
            case 'sms':
                consumo = 'SMS';
                break;
            case 'email':
                consumo = 'Correo';
                break;
            case 'whatsapp':
                consumo = 'WhatsApp';
                break;
            case 'voz':
                consumo = 'Voz';
                break;
        }
        return (
            consumo
        );

    }

    const formatPhoneNumber = (phone) => {
        if (!phone) return '';
        const cleaned = phone.replace(/[^\d+]/g, '');
        const match = cleaned.match(/^(\+?52)(1?)(\d{10})$/);
        if (match) {
            const prefix = match[1];
            const isMobile = match[2];
            const number = match[3];
            const formatted = `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
            return `${prefix} ${isMobile} ${formatted}`.trim();
        }
        const localMatch = cleaned.match(/^(\d{10})$/);
        if (localMatch) {
            const number = localMatch[1];
            return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
        }
        return phone;
    }
    return (
        <Card className="h-100 " style={{ overflow: 'auto' }}>
            <Card.Body className="pt-0">
                {/*  <Row className="d-flex justify-content-between">
                        <Col className="text-start pt-2">
                            <h6 >Consumo de Email</h6>
                        </Col>
                        <Col xs="auto">
                            <div style={{ height: 60 }}>
                                <Button
                                    className="btn-primary d-flex justify-content-stretch align-items-center"
                                    title={`Total máximo de mensajes: ${mensajesEmail !== null ? mensajesEmail.length : 0}`}
                                >
                                    <SmsIcon />
                                    <div style={{ width: 10 }} />
                                    {mensajesSelEmail !== null ? mensajesSelEmail.length : 0}
                                </Button>
                            </div>
                        </Col>
                    </Row> */}
                {(
                    <>
                        {/* Lista del resultado del filtro */}
                        <Row>
                            <Col md={12} xs={12}>

                                {<ConsumoTableListTanstack
                                    data={
                                        [...(store.mensajesSelSms || []), ...(store.mensajesSelEmail || []), ...(store.mensajesSelWhatsapp || []), ...(store.mensajesSelVoz || [])]
                                            .filter(w => {
                                                let formmated = formatTypeConsumo(w).toLowerCase();
                                                return filtroSelTipoConsumo.includes(formmated);
                                            }).map((item, index) => {
                                                let vehiculo = store.vehiculos.find(w => w.idvehiculo === item.idvehiculo);
                                                let no_economico = vehiculo !== null ? `${vehiculo.no_economico} / ${vehiculo.alias}` : '';
                                                let newItem = {
                                                    ...item,
                                                    consumo: formatTypeConsumo(item),
                                                    vehiculo: no_economico,
                                                    fecha: formatFecha(item.fechaHoraEvento),
                                                    fechaHoraEvento: formatFecha(item.fechaHoraEvento),
                                                    destino: formatPhoneNumber(item.destino),
                                                    destinoSinFormato: item.destino
                                                };
                                                return newItem;
                                            })
                                            .sort((a, b) => {
                                                const fechaA = new Date(a.fecha);
                                                const fechaB = new Date(b.fecha);
                                                return fechaA.getTime() - fechaB.getTime();
                                            })
                                    }
                                    columns={columns}
                                    title={"Lista de consumos"}
                                    isGroup={true}
                                    isLoading={false}
                                    pageSize={perPage}
                                    searchValue={searchValue}
                                    onSearch={setSearchValue}
                                    onPageSizeChange={handlePageSizeChange}
                                />}

                                {/* <MasterTableConsumos
                                    data={[...(store.mensajesSelSms || []), ...(store.mensajesSelEmail || []), ...(store.mensajesSelWhatsapp || []), ...(store.mensajesSelVoz || [])].sort((a, b) => {
                                        const fechaA = new Date(a.fecha);
                                        const fechaB = new Date(b.fecha);
                                        return fechaA.getTime() - fechaB.getTime();
                                    })}
                                    title={"Lista de consumos"}
                                    perPage={5}
                                    isGroup={true}
                                    counterButton={
                                        <></>
                                    }
                                /> */}
                            </Col>
                        </Row>
                    </>
                )}
            </Card.Body>
        </Card>
    )

}

export default CardConsumos;